import React from 'react';
import { motion } from 'framer-motion';
export const BonusSection: React.FC = () => {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    tag: 'BONUS #1',
    title: 'Biblioteca de 50 Intervenciones Clínicas Rápidas',
    desc: 'Frases, preguntas y recursos listos para usar cuando el paciente se bloquea, divaga, evita temas o no sabés cómo avanzar.',
    img: 'https://cdn.magicpatterns.com/uploads/r1McHmQa7gKZzfpgT3SgSg/3.png'
  }, {
    tag: 'BONUS #2',
    title: 'Guía Express para la Primera Sesión',
    desc: 'El paso a paso para conducir primeras entrevistas con más seguridad, ordenar la demanda y cerrar con claridad profesional.',
    img: 'https://cdn.magicpatterns.com/uploads/5QDTmMFe6nsujDXqaXo1US/2.png'
  }, {
    tag: 'BONUS #3',
    title: 'Kit Planillas para Consultas',
    desc: 'Complemento ideal para mantener todo el registro de tus pacientes organizado y accesible en todo momento.',
    img: 'https://cdn.magicpatterns.com/uploads/ghFNAEFXjEjmTkkr48zJEA/4.png'
  }];
  return <section className="py-12 md:py-20 px-4 bg-navy-800 relative overflow-hidden" data-id="element-14">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent opacity-50" data-id="element-15"></div>

      <div className="max-w-md md:max-w-6xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-17">
          <h2 className="text-2xl md:text-5xl font-extrabold mb-2 text-white" data-id="element-18">
            OFERTA ESPECIAL:{' '}
            <span className="text-gold-500" data-id="element-19">
              BONUS PROFESIONALES GRATIS HOY
            </span>
          </h2>
        </motion.div>

        <div className="space-y-5 md:space-y-0 md:grid md:grid-cols-3 md:gap-8" data-id="element-20">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-navy-900 rounded-xl md:rounded-2xl border border-gold-500/30 overflow-hidden relative group flex flex-col" data-id="element-21">
              <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-red-600 text-white text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full z-10 animate-pulse" data-id="element-22">
                ¡GRATIS HOY!
              </div>

              <div className="p-4 md:p-6 bg-navy-800/50 flex justify-center items-center h-48 md:h-64 cursor-pointer" onClick={scrollToPricing} data-id="element-23">
                <img src={bonus.img} alt={bonus.title} className="max-h-full object-contain drop-shadow-xl group-hover:scale-110 transition-transform duration-500" data-id="element-24" />
              </div>

              <div className="p-4 md:p-6 flex-1 flex flex-col" data-id="element-25">
                <span className="text-gold-500 font-bold text-xs md:text-sm mb-1 md:mb-2 block" data-id="element-26">
                  {bonus.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed flex-1" data-id="element-28">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};